@if (loading) {
<div class="hero h-fix" [ngStyle]="{
      'background-image':
        'url(' + (travel | travelImagePipe | imagePipe: 'travel' : 'lg') + ')',
    }">
  <div class="gradient"></div>
</div>
<div class="backdrop-mini-loader">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
</div>
} @else {
@if (travel) {
<div class="hero" [ngStyle]="{
        'background-image':
          'url(' +
          (travel | travelImagePipe | imagePipe: 'travel' : 'lg') +
          ')',
      }">
  <div class="gradient"></div>
  <div class="container">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-8 pr-5">
        <div class="banner-travel-title">
          <div>
            <h1 class="mt-0 inline">{{ travel.name | titlecase }}</h1>
            <!-- @if( checkDatesForAlert() ){
                    <span>
                      <div class="card-alert-title-travel-page danger" pTooltip="In partenza!" tooltipPosition="top">
                        <img src="/assets/media/icons/dep-time.png" class="alert-img"/>
                      </div>
                    </span>
                  } -->
            <!-- @if( checkForAvailability() ){
                    <span>
                      <div class="card-alert-title-travel-page danger" pTooltip="Posti quasi esauriti!" tooltipPosition="top">
                        <img src="/assets/media/icons/alert.png" class="alert-img">
                      </div>
                    </span>
                  } -->
            <!-- @if( travel.availability?.max === travel.availability?.booked ){
                    <span>
                      <div class="card-alert-title-travel-page danger" pTooltip="Al completo!" tooltipPosition="top">
                        <img src="/assets/media/icons/hand.png" class="alert-img">
                      </div>
                    </span>
                  } -->
            <!-- @if( travel.draft ){
                    <span pTooltip="Viaggio in bozza" tooltipPosition="top">
                      <div class="card-alert-title-travel-page danger">
                        <img src="/assets/media/icons/draft.png" class="alert-img">
                      </div>
                    </span>
                    } -->
          </div>
          <span class="mt-2">{{
            travel.payoff || "Descrizione non disponibile"
            }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobile">
  <div class="travel-card card-dep">
    <div class="info">
      <!-- @if (travel.booking_deadline) {
            <div class="flex align-items-center gap-3 mb-3 cat_icon">
              <img src="/assets/media/icons/bell-o.png" />
              <small class="yellow font-medium"
                >Puoi prenotare fino al
                <strong>
                  {{ travel.booking_deadline | date: "dd MMMM yyyy" }}</strong
                ></small
              >
            </div>
          } -->
      @if (travel.booking_deadline) {
      @if (travel.booking_deadline | bookingExpired) {
      <div class="flex align-items-center gap-3 mt-3">
        <small class="not-bookable font-medium">
          <strong>Prenotazioni chiuse per questo viaggio</strong>
        </small>
      </div>
      } @else {
      <div class="flex align-items-center gap-3 mt-3">
        <img src="/assets/media/icons/bell-o.png" />
        <small class="yellow font-medium">
          Puoi prenotare fino al
          <strong>{{
            travel.booking_deadline | date: "dd MMMM yyyy"
            }}</strong>
        </small>
      </div>
      }
      }
      <div class="flex align-items-start justify-content-between gap-5 mb-4">
        @if (!travel.funding) {
        <div class="travel-card-price">
          <h1 class="green m-0">
            Da
            {{
            travel.pricing_mode === 1
            ? (travel.price_room
            | currency: travel.currency : "symbol" : ".0-0")
            : (cheapestPackagePrice
            | currency: travel.currency : "symbol" : ".0-0")
            }}
          </h1>
          @if (
          travel.checkout_full_payment === false &&
          travel.checkout_advance
          ) {
          <small class="text-xs">Acconto a partire da
            {{
            travel.checkout_advance
            | currency: travel.currency : "symbol" : ".0-0"
            }}
            @if (travel.addl_insurances) {
            *
            }
          </small>
          @if (travel.addl_insurances) {
          <small class="block text-xs text-400 mt-1">* Assicurazione annullamento e medico bagaglio escluse
          </small>
          }
          }
        </div>
        }

        <div class="share-group flex align-items-center gap-3">
          @if (travel.youtube_url) {
          <div class="share flex align-items-center justify-content-center" pTooltip="Guarda il video"
            tooltipPosition="top">
            <a [href]="travel.youtube_url" target="_blank">
              <img src="/assets/media/icons/youtube.png" />
            </a>
          </div>
          }
          <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
            pTooltip="Condividi" tooltipPosition="top" (click)="openShareOnSocialsModal()">
            <img src="/assets/media/icons/share.png" />
          </div>
          @if (auth.isLogged()) {
          @if (!isInFavs) {
          <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
            pTooltip="Aggiungi ai preferiti" tooltipPosition="top" (click)="addToFavs(travel.id)">
            <img src="/assets/media/icons/heart.png" />
          </div>
          } @else {
          <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
            pTooltip="Rimuovi dai preferiti" tooltipPosition="top" (click)="removeFromFavs(travel.id)">
            <img src="/assets/media/icons/broken-heart.png" />
          </div>
          }
          }
        </div>
      </div>

      <div class="flex align-items-center gap-3 mb-3">
        <img src="/assets/media/icons/departures.png" />
        @if (travel.from_date && !travel.to_date) {
        <small><strong>{{ travel.from_date | date: "dd MMMM yyyy" }} - Ritorno non
            indicato</strong></small>
        } @else if (!travel.from_date && travel.to_date) {
        <small><strong>Andata non indicata -
            {{ travel.to_date | date: "dd MMMM yyyy" }}</strong></small>
        } @else if (!travel.from_date && !travel.to_date) {
        <small><strong>Date non indicate</strong></small>
        } @else if (travel.from_date && travel.to_date) {
        <small><strong>{{ travel.from_date | date: "dd MMMM yyyy" }} -
            {{ travel.to_date | date: "dd MMMM yyyy" }}</strong></small>
        }
      </div>

      @if (travel.optional_flight_purchase === true) {
      <div class="flex align-items-center gap-3 mb-3">
        <img src="/assets/media/icons/airplane-ticket.png" />
        <small>Con o senza volo</small>
      </div>
      }
      @for (cat of travel.categories; track $index) {
      <div class="flex align-items-center gap-3 mb-3 cat_icon">
        <img [src]="cat.category.id | travelType" />
        <small>{{ cat.category.name }}</small>
      </div>
      }

      @if (!travel.funding) {
      <div class="flex align-items-center gap-3">
        <img src="/assets/media/icons/group.png" />
        @if (travel.max_members) {
        <small>Fino a {{ travel.max_members }} partecipanti</small>
        } @else {
        <small>Max numero di partecipanti non indicato</small>
        }
      </div>
      }
    </div>
    <div class="organization-info">
      @if (travel.player) {
      <div class="flex align-items-center gap-3">
        <p-avatar [image]="travel.player.logo | imagePipe: 'registry' : 'sm'" shape="circle"></p-avatar>
        <div class="flex flex-column gap-2">
          <small>Offerto da: <br />
            <strong class="clickable" (click)="goTo()">{{
              travel.player.name
              }}</strong>
          </small>
        </div>
      </div>
      }
      @if (
      this.travel.assignment &&
      this.travel.assignment.status.id === enumAssignmentStatus.ACCEPTED
      ) {
      <div class="flex align-items-center gap-3 mt-3">
        <p-avatar shape="circle" [image]="
                  travel.assignment.target_user.profile_picture
                    | imagePipe: 'user' : 'sm'
                "></p-avatar>
        <div class="flex flex-column gap-2" [routerLink]="[
                  '/user/profile',
                  travel.assignment.target_user.username,
                ]">
          <small>Tour Leader: <br />
            <strong class="clickable">{{ travel.assignment.target_user.name }}
              {{ travel.assignment.target_user.last_name }}</strong>
          </small>
        </div>
      </div>
      }
      @if (!travel.assignment) {
      <div class="flex align-items-center gap-3 mt-3">
        <p-avatar [image]="
                  travel.related_user.profile_picture | imagePipe: 'user' : 'sm'
                " shape="circle"></p-avatar>
        <div class="flex flex-column gap-2" [routerLink]="['/user/profile', travel.related_user.username]">
          <small>Tour Leader: <br />
            @if (travel.related_user.name) {
            <strong class="clickable">{{ travel.related_user.name }}
              {{ travel.related_user.last_name }}</strong>
            } @else {
            <strong class="clickable">{{
              travel.related_user.username
              }}</strong>
            }
          </small>
        </div>
      </div>
      }
    </div>
    @if (travel.companions.length > 0) {
    <div class="organization-info">
      <div class="flex align-items-center gap-3">
        <p-avatar [image]="
                  travel.companions[0].companion.profile_picture
                    | imagePipe: 'user-w' : 'sm'
                " shape="circle"></p-avatar>
        <div class="flex flex-column gap-2" [routerLink]="[
                  '/companions/companion-profile',
                  travel.companions[0].companion.id,
                ]">
          <small>Accompagnatore: <br />
            <strong class="clickable">{{ travel.companions[0].companion.name }}
              {{ travel.companions[0].companion.last_name }}</strong>
          </small>
        </div>
      </div>
    </div>
    }
    <footer>
      <div class="w-full">
        @if (
        travel.max_members &&
        travel.max_members === travel.availability!.booked
        ) {
        <h3 class="text-center red-text">Posti esauriti</h3>
        }
        <!-- FUNDING TRUE BOTTONI VISIBILI ANCHE DA OSPITE -->
        @else {
        @if (auth.isLogged()) {
        @if (travel.funding === true) {
        <div class="flex justify-content-between gap-3">
          <div [ngClass]="{
                        cursorNotAllowed:
                          isTravelPast() ||
                          auth.getUser().id === travel.related_user.id ||
                          alreadyJoined() ||
                          travel.draft,
                      }">
            <p-button styleClass="w-full slide" label="Aderisci" (click)="goToCheckout()" [disabled]="
                          isTravelPast() ||
                          auth.getUser().id === travel.related_user.id ||
                          alreadyJoined() ||
                          travel.draft
                        "></p-button>
          </div>
          <div [ngClass]="{ cursorNotAllowed: travel.draft }">
            <p-button styleClass="w-full slide" label="Dona" (click)="goToDonate()"
              [disabled]="travel.draft"></p-button>
          </div>
        </div>
        } @else {
        <!-- <div [ngClass]="{
                      cursorNotAllowed:
                        isTravelPast() ||
                        auth.getUser().id === travel.related_user.id ||
                        alreadyJoined() ||
                        travel.draft,
                    }">
          <p-button styleClass="w-full slide" label="Partecipa" (click)="goToCheckout()" [disabled]="
                        isTravelPast() ||
                        auth.getUser().id === travel.related_user.id ||
                        alreadyJoined() ||
                        travel.draft ||
                        (travel.booking_deadline | bookingExpired)
                      "></p-button>
        </div> -->
        <div [ngClass]="{
                      cursorNotAllowed:
                        isTravelPast() ||
                        auth.getUser().id === travel.related_user.id ||
                        alreadyJoined() ||
                        travel.draft,
                    }">
          @if (travel.visibility.id === 4 && !canJoinByCommunity) {
          <!-- NON appartiene alla community -->
          <div class="p-3 border-round mb-3 community-warning">
            <div class="flex align-items-start gap-2 mb-2">
              <i class="pi pi-lock text-lg"></i>
              <small class="font-medium">
                Questo viaggio è riservato
                all{{ travelCommunities.length === 1 ? 'a' : 'e' }}
                communit{{ travelCommunities.length === 1 ? 'y' : 'ies' }}:

              </small>
            </div>
            @for (community of travelCommunities; track community.id) {

            <div class="community-card flex align-items-center">

              @if (community.picture) {
              <div class="community-img mr-3 mb-2 mt-2">
                <img [src]="community.picture | imagePipe:'user':'sm'">
              </div>
              } @else {
              <div class="community-img placeholder mr-3 mb-2">
                <img src="/assets/media/icons/photos.png">
              </div>
              }

              <strong>{{ community.name | titlecase }}</strong>
            </div>

            }

            <small class="mt-1 block font-medium">
              Unisciti per poter viaggiare con noi.
            </small>
          </div>

          <!-- 
          <p-button styleClass="w-full slide" label="Unisciti" (click)="goTo('/community')"></p-button> -->
          <p-button styleClass="w-full slide" label="Unisciti" (click)="goToCommunity()" [disabled]="!!(travel.booking_deadline | bookingExpired)"></p-button>
          } @else {
          <!-- appartiene alla community -->
          <p-button styleClass="w-full slide" label="Partecipa" (click)="goToCheckout()" [disabled]="
                          isTravelPast() ||
                          auth.getUser().id === travel.related_user.id ||
                          alreadyJoined() ||
                          travel.draft ||
                          (travel.booking_deadline | bookingExpired)
                        "></p-button>
          }
        </div>
        }
        } @else {
        @if (travel.funding === true) {
        <div class="flex justify-content-between gap-3">
          <div [ngClass]="{ cursorNotAllowed: isTravelPast() }">
            <p-button styleClass="w-full h-3rem w-10rem slide" label="Aderisci" (click)="goTo('/login')"
              [disabled]="isTravelPast() || alreadyJoined()"></p-button>
          </div>
          <p-button styleClass="w-full h-3rem w-10rem slide" label="Dona" (click)="showOptionalLogin()"></p-button>
        </div>
        } @else {
        <p-button styleClass="w-full slide" label="Accedi / Registrati" (click)="goTo('/login')"></p-button>
        <div [ngClass]="{
                      cursorNotAllowed: isTravelPast(),
                    }">
          @if (travel.visibility.id !== 4) {
          <div class="out-green my-4">
            <p-button styleClass="w-full" label="Continua come ospite" (click)="goTo('/guest')" [outlined]="true"
              [disabled]="isTravelPast()"></p-button>
          </div>}
        </div>
        }
        }
        }
      </div>
    </footer>
  </div>
</div>
<div class="container travel-card-container">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-8 pr-5">
      <div class="screen mb-3 breadcrumb" #general>
        <!-- @if (getTravel_metadata(0)) {
              <div class="mb-3 font-italic text-xs">
                Photo by
                <a
                  target="_blank"
                  [href]="
                    getTravel_metadata(0).author_url +
                    '?utm_source=SocialTravels FE&utm_medium=referral'
                  "
                  >{{ getTravel_metadata(0).author }}</a
                >
                on
                <a
                  target="_blank"
                  href="https://unsplash.com/?utm_source=SocialTravels FE&utm_medium=referral"
                  >Unsplash</a
                >
              </div>
            } -->
        <p-breadcrumb [model]="items" />
      </div>
      @if ((travel | travelStatus) !== "future") {
      <div class="status-alert mb-3" [ngClass]="{
                ongoing: (travel | travelStatus) === 'ongoing',
                past: (travel | travelStatus) === 'past',
              }">
        <div class="flex flex-column gap-1">
          <strong>
            {{
            (travel | travelStatus) === "ongoing"
            ? "Questo viaggio è attualmente in corso"
            : "Questo viaggio è già concluso"
            }}
          </strong>

          <small>
            {{
            (travel | travelStatus) === "ongoing"
            ? "Il viaggio è attivo in questo momento."
            : "Il viaggio si è già svolto."
            }}
          </small>
        </div>
      </div>
      }

      @if (checkForAvailability()) {
      <div class="muted-r-bg alert-in-page mb-3">
        <div class="flex align-items-center gap-3">
          <div class="card-alert-title-travel-page danger">
            <img src="/assets/media/icons/alert.png" class="alert-img" />
          </div>
          <div class="flex flex-column gap-1">
            <strong>Questo viaggio è quasi al completo!</strong>
            <small>Affrettati a partecipare per assicurarti il posto.</small>
          </div>
        </div>
      </div>
      }

      @if (
      travel.booking_deadline && travel.booking_deadline | bookingExpired
      ) {
      <div class="muted-r-bg alert-in-page mb-3">
        <div class="flex align-items-center gap-3">
          <div class="card-alert-title-travel-page danger">
            <img src="/assets/media/icons/hand.png" class="alert-img" />
          </div>
          <div class="flex flex-column gap-1">
            <strong>Questo viaggio è in partenza!</strong>
            <small>Purtroppo questo viaggio non è più disponibile, ma continua
              a esplorare il sito, troverai sicuramente un’altra proposta
              perfetta per te.</small>
          </div>
        </div>
      </div>
      } @else if (checkDatesForAlert()) {
      <div class="muted-r-bg alert-in-page mb-3">
        <div class="flex align-items-center gap-3">
          <div class="card-alert-title-travel-page danger">
            <img src="/assets/media/icons/hand.png" class="alert-img" />
          </div>
          <div class="flex flex-column gap-1">
            <strong>Questo viaggio è in partenza!</strong>
            <small>Manca poco e aspettiamo solo te.</small>
          </div>
        </div>
      </div>
      }

      @if (travel.availability?.max === travel.availability?.booked) {
      <div class="muted-r-bg alert-in-page mb-3">
        <div class="flex align-items-center gap-3">
          <div class="card-alert-title-travel-page danger">
            <img src="/assets/media/icons/hand.png" class="alert-img" />
          </div>
          <div class="flex flex-column gap-1">
            <strong>Questo viaggio è al completo!</strong>
            <small>Non è più possibile partecipare, i posti sono
              terminati.</small>
          </div>
        </div>
      </div>
      }
      @if (travel.draft) {
      <div class="muted-r-bg alert-in-page mb-3">
        <div class="flex align-items-center gap-3">
          <div class="card-alert-title-travel-page danger">
            <img src="/assets/media/icons/draft.png" class="alert-img" />
          </div>
          <div class="flex flex-column gap-1">
            <strong>Questo viaggio è in bozza!</strong>
            <small>In questa fase, solo l'organizzatore può modificarlo o
              pubblicarlo.</small>
          </div>
        </div>
      </div>
      }

      <div class="highlighted" #program>
        <h2 class="mt-0">Panoramica del viaggio</h2>
        <div [innerHTML]="travel.summary || 'Panoramica non indicata.'"></div>
      </div>

      <h2>Programma</h2>
      <div class="travel-program" [class.compressed]="!showTravelProgram" [class.show]="showTravelProgram"
        [hidden]="travel.program.length === 0">
        <div>
          @for (p of travel.program; track $index) {
          <div>
            <strong>{{ p.title }}</strong>
            <br />
            <div class="bl-dashed">
              <p class="ml-4 my-5">{{ p.description }}</p>
            </div>
          </div>
          }
        </div>
      </div>

      @if (travel.program.length > 0) {
      <div class="show-more-container flex align-items-center justify-content-center gap-1" #flights>
        <span (click)="showTravelProgram = !showTravelProgram" class="show-more-text link-o">{{ showTravelProgram ?
          "Mostra meno" : "Mostra tutto" }}</span>
        @if (!showTravelProgram) {
        <i class="green pi pi-angle-down text-xs"></i>
        } @else {
        <i class="green pi pi-angle-up text-xs"></i>
        }
      </div>
      } @else {
      <div class="empty-message mt-0">Nessun dato disponibile</div>
      }
      @if (travel.has_flights === true) {
      <div class="mt-5">
        <h2>Partenze e voli</h2>
        <div class="grid">
          @if (travel.departures.length > 0) {
          <div class="col-6">
            <strong>Andata</strong>
            @for (d of travel.departures; track $index) {
            <div class="flex align-items-start gap-3 mt-3">
              <img src="/assets/media/icons/going.png" height="24" />
              <div class="flex flex-column gap-1">
                <span><strong>{{
                    d.flight.flight_company?.name ||
                    "Compagnia non indicata"
                    }}</strong>
                  <br />
                  {{
                  d.flight.from_airport?.name ||
                  "Aeroporto non indicato"
                  }}
                  ({{
                  d.flight.from_airport?.code ||
                  "Codice volo non indicato"
                  }}) »
                  {{
                  d.flight.to_airport?.name ||
                  "Aeroporto non indicato"
                  }}
                  ({{
                  d.flight.to_airport?.code ||
                  "Codice volo non indicato"
                  }})</span>
                <small>{{
                  d.flight.departure_date
                  | date: "dd/MM/yyyy, HH:mm"
                  }}
                  »
                  {{
                  d.flight.arrival_date | date: "dd/MM/yyyy, HH:mm"
                  }}</small>
              </div>
            </div>
            }
          </div>
          }
          @if (travel.arrivals.length > 0) {
          <div class="col-6">
            <strong>Ritorno</strong>
            @for (a of travel.arrivals; track $index) {
            <div class="flex align-items-start gap-3 mt-3">
              <img src="/assets/media/icons/going-back.png" height="24" />
              <div class="flex flex-column gap-1">
                <span><strong>{{
                    a.flight.flight_company?.name ||
                    "Compagnia non indicata"
                    }}</strong>
                  <br />
                  {{
                  a.flight.from_airport?.name ||
                  "Aeroporto non indicato"
                  }}
                  ({{
                  a.flight.from_airport?.code ||
                  "Codice volo non indicato"
                  }}) »
                  {{
                  a.flight.to_airport?.name ||
                  "Aeroporto non indicato"
                  }}
                  ({{
                  a.flight.to_airport?.code ||
                  "Codice volo non indicato"
                  }})</span>
                <small>{{
                  a.flight.departure_date
                  | date: "dd/MM/yyyy, HH:mm"
                  }}
                  »
                  {{
                  a.flight.arrival_date | date: "dd/MM/yyyy, HH:mm"
                  }}</small>
              </div>
            </div>
            }
          </div>
          }
        </div>
        @if (
        travel.departures.length === 0 && travel.arrivals.length === 0
        ) {
        <div class="empty-message mt-0">Nessun dato disponibile</div>
        }
      </div>
      }

      <div class="mt-5">

        <h2>Luoghi del viaggio</h2>
        <div class="flex align-items-center gap-2 flex-wrap">
          <img src="/assets/media/icons/world.png" height="24" />
          @for (country of travel.countries; track $index) {
          <span class="yellow font-medium">{{
            country.country.name
            }}</span>
          }
        </div>

        <div class="flex align-items-center gap-2 flex-wrap mt-2">
          <img src="/assets/media/icons/map-location.png" height="24" />
          @for (city of travel.cities; track $index) {
          <span class="text-gray-600">{{ city | titlecase }}</span>
          }
        </div>
      </div>
    </div>
    <div class="screen custom-margin col-12 md:col-12 lg:col-4 p-0 pb-5">
      <div class="travel-card card-dep">
        <div class="info">
          <!-- @if (travel.booking_deadline) {
                <div class="flex align-items-center gap-3 mb-3 cat_icon">
                  <img src="/assets/media/icons/bell-o.png" />
                  <small class="yellow font-medium"
                    >Puoi prenotare fino al
                    <strong>
                      {{
                        travel.booking_deadline | date: "dd MMMM yyyy"
                      }}</strong
                    ></small
                  >
                </div>
              } -->
          @if (travel.booking_deadline) {
          @if (travel.booking_deadline | bookingExpired) {
          <div class="flex align-items-center gap-3 mt-3">
            <small class="not-bookable font-medium">
              <strong>Prenotazioni chiuse per questo viaggio</strong>
            </small>
          </div>
          } @else {
          <div class="flex align-items-center gap-3 mt-3">
            <img src="/assets/media/icons/bell-o.png" />
            <small class="yellow font-medium">
              Puoi prenotare fino al
              <strong>{{
                travel.booking_deadline | date: "dd MMMM yyyy"
                }}</strong>
            </small>
          </div>
          }
          }
          <div class="flex align-items-start justify-content-between gap-5 mb-4">
            @if (!travel.funding) {
            <div class="travel-card-price">
              <h1 class="green m-0">
                Da
                {{
                travel.pricing_mode === 1
                ? (travel.price_room
                | currency: travel.currency : "symbol" : ".0-0")
                : (cheapestPackagePrice
                | currency: travel.currency : "symbol" : ".0-0")
                }}
              </h1>
              @if (
              travel.checkout_full_payment === false &&
              travel.checkout_advance
              ) {
              <small class="text-xs">Acconto a partire da
                {{
                travel.checkout_advance
                | currency: travel.currency : "symbol" : ".0-0"
                }}
                @if (travel.addl_insurances) {
                *
                }
              </small>
              @if (travel.addl_insurances) {
              <small class="block text-xs text-400 mt-1">* Assicurazione annullamento e medico bagaglio
                escluse
              </small>
              }
              }
            </div>
            }

            <div class="share-group flex align-items-center gap-3">
              @if (travel.youtube_url) {
              <div class="share flex align-items-center justify-content-center" pTooltip="Guarda il video"
                tooltipPosition="top">
                <a [href]="travel.youtube_url" target="_blank">
                  <img src="/assets/media/icons/youtube.png" />
                </a>
              </div>
              }
              <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
                pTooltip="Condividi" tooltipPosition="top" (click)="openShareOnSocialsModal()">
                <img src="/assets/media/icons/share.png" />
              </div>
              @if (auth.isLogged()) {
              @if (!isInFavs) {
              <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
                pTooltip="Aggiungi ai preferiti" tooltipPosition="top" (click)="addToFavs(travel.id)">
                <img src="/assets/media/icons/heart.png" />
              </div>
              } @else {
              <div [ngClass]="{ disabled: travel.draft }" class="share flex align-items-center justify-content-center"
                pTooltip="Rimuovi dai preferiti" tooltipPosition="top" (click)="removeFromFavs(travel.id)">
                <img src="/assets/media/icons/broken-heart.png" />
              </div>
              }
              }
            </div>
          </div>
          <div class="flex align-items-center gap-3 mb-3">
            <img src="/assets/media/icons/departures.png" />
            @if (travel.from_date && !travel.to_date) {
            <small><strong>{{ travel.from_date | date: "dd MMMM yyyy" }} - Ritorno
                non indicato</strong></small>
            } @else if (!travel.from_date && travel.to_date) {
            <small><strong>Andata non indicata -
                {{ travel.to_date | date: "dd MMMM yyyy" }}</strong></small>
            } @else if (!travel.from_date && !travel.to_date) {
            <small><strong>Date non indicate</strong></small>
            } @else if (travel.from_date && travel.to_date) {
            <small><strong>{{ travel.from_date | date: "dd MMMM yyyy" }} -
                {{ travel.to_date | date: "dd MMMM yyyy" }}</strong></small>
            }
          </div>
          <!-- 
          @if(travel.optional_flight_purchase === true){
          <div class="flex align-items-center gap-3 mb-3">
            <img src="/assets/media/icons/airplane-ticket.png" />
            <small>Con o senza volo</small>
          </div>
          }  -->
          @for (cat of travel.categories; track $index) {
          <div class="flex align-items-center gap-3 mb-3 cat_icon">
            <img [src]="cat.category.id | travelType" />
            <small>{{ cat.category.name }}</small>
          </div>
          }
          @if (!travel.funding) {
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/group.png" />
            @if (travel.max_members) {
            <small>Fino a {{ travel.max_members }} partecipanti</small>
            } @else {
            <small>Max numero di partecipanti non indicato</small>
            }
          </div>
          }
        </div>
        <div class="organization-info">
          @if (travel.player) {
          <div class="flex align-items-center gap-3">
            <p-avatar [image]="travel.player.logo | imagePipe: 'registry' : 'sm'" shape="circle"></p-avatar>
            <div class="flex flex-column gap-2">
              <small>Offerto da: <br />
                <strong class="clickable" (click)="goTo()">{{
                  travel.player.name
                  }}</strong>
              </small>
            </div>
          </div>
          }
          @if (
          this.travel.assignment &&
          this.travel.assignment.status.id ===
          enumAssignmentStatus.ACCEPTED
          ) {
          <div class="flex align-items-center gap-3 mt-3">
            <p-avatar shape="circle" [image]="
                      travel.assignment.target_user.profile_picture
                        | imagePipe: 'user' : 'sm'
                    "></p-avatar>
            <div class="flex flex-column gap-2" [routerLink]="[
                      '/user/profile',
                      travel.assignment.target_user.username,
                    ]">
              <small>Tour Leader: <br />
                <strong class="clickable">{{ travel.assignment.target_user.name }}
                  {{ travel.assignment.target_user.last_name }}</strong>
              </small>
            </div>
          </div>
          }
          @if (!travel.assignment) {
          <div class="flex align-items-center gap-3 mt-3">
            <p-avatar [image]="
                      travel.related_user.profile_picture
                        | imagePipe: 'user' : 'sm'
                    " shape="circle"></p-avatar>
            <div class="flex flex-column gap-2" [routerLink]="[
                      '/user/profile',
                      travel.related_user.username,
                    ]">
              <small>Tour Leader: <br />
                @if (travel.related_user.name) {
                <strong class="clickable">{{ travel.related_user.name }}
                  {{ travel.related_user.last_name }}</strong>
                } @else {
                <strong class="clickable">{{
                  travel.related_user.username
                  }}</strong>
                }
              </small>
            </div>
          </div>
          }
        </div>
        @if (travel.companions.length > 0) {
        <div class="organization-info">
          <div class="flex align-items-center gap-3">
            <p-avatar [image]="
                      travel.companions[0].companion.profile_picture
                        | imagePipe: 'user-w' : 'sm'
                    " shape="circle"></p-avatar>
            <div class="flex flex-column gap-2" [routerLink]="[
                      '/companions/companion-profile',
                      travel.companions[0].companion.id,
                    ]">
              <small>Accompagnatore: <br />
                <strong class="clickable">{{ travel.companions[0].companion.name }}
                  {{ travel.companions[0].companion.last_name }}</strong>
              </small>
            </div>
          </div>
        </div>
        }
        <footer>
          <div class="w-full">
            @if (
            travel.max_members &&
            travel.max_members === travel.availability!.booked
            ) {
            <h3 class="text-center red-text">Posti esauriti</h3>
            }
            <!-- FUNDING TRUE BOTTONI VISIBILI ANCHE DA OSPITE -->
            @else {
            @if (auth.isLogged()) {
            @if (travel.funding === true) {
            <div class="flex justify-content-between gap-3">
              <div [ngClass]="{
                            cursorNotAllowed:
                              isTravelPast() ||
                              auth.getUser().id === travel.related_user.id ||
                              alreadyJoined() ||
                              travel.draft,
                          }">
                <p-button styleClass="w-full slide" label="Aderisci" (click)="goToCheckout()" [disabled]="
                              isTravelPast() ||
                              auth.getUser().id === travel.related_user.id ||
                              alreadyJoined() ||
                              travel.draft
                            "></p-button>
              </div>
              <div [ngClass]="{ cursorNotAllowed: travel.draft }">
                <p-button styleClass="w-full slide" label="Dona" (click)="goToDonate()"
                  [disabled]="travel.draft"></p-button>
              </div>
            </div>
            } @else {
            <!-- <div
                        [ngClass]="{
                          cursorNotAllowed:
                            isTravelPast() ||
                            auth.getUser().id === travel.related_user.id ||
                            alreadyJoined() ||
                            travel.draft,
                        }"
                      >
                        <p-button
                          styleClass="w-full slide"
                          label="Partecipa"
                          (click)="goToCheckout()"
                          [disabled]="
                            isTravelPast() ||
                            auth.getUser().id === travel.related_user.id ||
                            alreadyJoined() ||
                            travel.draft ||
                            (travel.booking_deadline | bookingExpired)
                          "
                        ></p-button>
                      </div> -->
            <div [ngClass]="{
                          cursorNotAllowed:
                            isTravelPast() ||
                            auth.getUser().id === travel.related_user.id ||
                            alreadyJoined() ||
                            travel.draft,
                        }">
              @if (travel.visibility.id === 4 && !canJoinByCommunity) {

              <!-- NON appartiene alla community -->
              <div class="p-3 border-round mb-3 community-warning">
                <div class="flex align-items-start gap-2 mb-2">
                  <i class="pi pi-lock text-lg"></i>
                  <small class="font-medium">
                    Questo viaggio è riservato
                    all{{ travelCommunities.length === 1 ? 'a' : 'e' }}
                    communit{{ travelCommunities.length === 1 ? 'y' : 'ies' }}:

                  </small>
                </div>


                @for (community of travelCommunities; track community.id) {

                <div class="community-card flex align-items-center">

                  @if (community.picture) {
                  <div class="community-img mr-3 mb-2 mt-2">
                    <img [src]="community.picture | imagePipe:'user':'sm'">
                  </div>
                  } @else {
                  <div class="community-img placeholder mr-3 mb-2">
                    <img src="/assets/media/icons/photos.png">
                  </div>
                  }

                  <strong>{{ community.name | titlecase }}</strong>
                </div>

                }


                <small class="mt-1 block font-medium">
                  Unisciti per poter viaggiare con noi.
                </small>
              </div>


              <!-- <p-button styleClass="w-full slide" label="Unisciti" (click)="goTo('/community')"></p-button> -->
              <p-button styleClass="w-full slide" label="Unisciti" (click)="goToCommunity()" [disabled]="!!(travel.booking_deadline | bookingExpired)"></p-button>

              } @else {
              <!-- appartiene alla community -->
              <p-button styleClass="w-full slide" label="Partecipa" (click)="goToCheckout()" [disabled]="
                              isTravelPast() ||
                              auth.getUser().id === travel.related_user.id ||
                              alreadyJoined() ||
                              travel.draft ||
                              (travel.booking_deadline | bookingExpired)
                             
                            "></p-button>
              }
            </div>
            }
            } @else {
            @if (travel.funding === true) {
            <div class="flex justify-content-between gap-3">
              <div [ngClass]="{ cursorNotAllowed: isTravelPast() }">
                <p-button styleClass="w-full h-3rem w-10rem slide" label="Aderisci" (click)="goTo('/login')"
                  [disabled]="isTravelPast() || alreadyJoined()"></p-button>
              </div>
              <p-button styleClass="w-full h-3rem w-10rem slide" label="Dona" (click)="showOptionalLogin()"></p-button>
            </div>
            } @else {
            <p-button styleClass="w-full slide" label="Accedi / Registrati" (click)="goTo('/login')"></p-button>
            <div [ngClass]="{
                          cursorNotAllowed: isTravelPast(),
                        }">
              @if (travel.visibility.id !== 4) {
              <div class="out-green my-4">
                <p-button styleClass="w-full" label="Continua come ospite" (click)="goTo('/guest')" [outlined]="true"
                  [disabled]="isTravelPast()"></p-button>
              </div>}
            </div>
            }
            }
            }
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>
@if (!travel.funding) {
<div class="bg-grey my-5" #price>
  <div class="container">
    <h2>Informazioni sul prezzo</h2>
    @if (travel.optional_flight_purchase === true) {
    <small>La quota comprende il volo. In fase di checkout potrai scegliere
      di acquistare il viaggio senza il volo pagando
      {{
      travel.optional_flight_purchase_discount
      | currency: travel.currency : "symbol" : ".2-2"
      }}
      in meno.
    </small>
    }
    <div class="grid mt-4">
      <div class="col-12 md:col-6">
        <strong>La quota comprende:</strong>
        <ul>
          @for (a of travel.price_includes; track $index) {
          <li>
            <div class="flex align-items-center gap-2">
              <img src="/assets/media/icons/check-g.png" height="24" />
              <span>{{ a }}</span>
            </div>
          </li>
          }
        </ul>
      </div>
      <div class="col-12 md:col-6">
        <strong>La quota non comprende:</strong>
        <ul>
          @for (e of travel.price_excludes; track $index) {
          <li>
            <div class="flex align-items-center gap-2">
              <img src="/assets/media/icons/cancel.png" height="20" />
              <span>{{ e }}</span>
            </div>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
} @else {
<div class="bg-grey my-5" #price>
  <div class="container">
    <h2>Informazioni sul prezzo</h2>

    <p class="mb-3">
      In questa fase è possibile aderire o effettuare una donazione.
      Ulteriori dettagli verranno comunicati non appena definiti
      dall’organizzatore.
    </p>
  </div>
</div>
}
<div class="container" #optionals>
  <div class="grid">
    <div class="col-12 md:col">
      @if (travel.addl_services.length > 0) {
      <div>
        <h2 class="mb-0">Servizi opzionali</h2>
        @for (add of travel.addl_services; track $index) {
        <div class="flex flex-column mt-3">
          <div class="flex align-items-center gap-3">
            <strong>{{ add.title }}:</strong>
            <h2 class="green m-0">
              {{
              add.price
              | currency: travel.currency : "symbol" : ".2-2"
              }}
            </h2>
          </div>
          <small class="grey-text">{{ add.description }}</small>
        </div>
        }
      </div>
      }
      @if (travel.undisclosed_members_list === false) {
      <div class="my-5" #insurance>
        <h2>Partecipanti</h2>
        @if (travelers && travelers.length > 0) {
        <div class="avatar-list">
          <p-avatarGroup>
            @for (a of travelers; track $index) {
            <p-avatar [image]="a.profile_picture | imagePipe: 'user-w' : 'sm'" shape="circle" size="large"
              [pTooltip]="a.name ? a.name : a.username" tooltipPosition="bottom"
              [routerLink]="['/user/profile', a.username]"></p-avatar>
            }
            @if (travelers.length < totalRecords) { <p-avatar label="..." shape="circle" size="large"
              (click)="loadMoreTravelers()" styleClass="avatar-text" [style]="{
                          'background-color': '#3c4e58',
                          color: '#ffffff',
                        }"></p-avatar>
              }
          </p-avatarGroup>
        </div>
        } @else {
        <small class="grey-text">Nessun traveler presente.</small>
        }
      </div>
      }
      @if (visibility_metadata) {
      <div class="my-5">
        <h2>Community associate</h2>
        <p-accordion [activeIndex]="activeIndexSelected">
          @for (c of visibility_metadata; track $index) {
          <p-accordionTab>
            <ng-template pTemplate="header">
              <div class="community-card flex" (click)="activeIndexSelected = $index">
                @if (c.picture) {
                <div class="community-img mr-3">
                  <img [src]="c.picture | imagePipe: 'user' : 'md'" />
                </div>
                } @else {
                <div class="community-img placeholder mr-3">
                  <img src="/assets/media/icons/photos.png" />
                </div>
                }
                <div class="flex flex-column gap-2 w-full">
                  <div class="flex align-items-center justify-content-between">
                    <div class="title flex gap-2 align-items-center">
                      <h3 class="m-0 text-lg">{{ c.name }}</h3>
                      <div class="flex gap-2">
                        @if (c.public === true) {
                        <div class="badge-container muted-t-bg flex align-items-center gap-1">
                          <i class="pi pi-lock-open"></i>
                          <small class="text-xs">Gruppo aperto</small>
                        </div>
                        } @else {
                        <div class="badge-container muted-r-bg flex align-items-center gap-1">
                          <i class="pi pi-lock"></i>
                          <small class="text-xs">Gruppo chiuso</small>
                        </div>
                        }
                        @if (c.users.length > 0) {
                        <div class="badge-container muted-o-bg flex align-items-center gap-1">
                          <i class="pi pi-users"></i>
                          <small class="text-xs">{{
                            c.users.length
                            }}</small>
                        </div>
                        }
                      </div>
                    </div>
                  </div>

                  <small class="white-space-normal">{{
                    c.text || "-"
                    }}</small>
                  <div class="flex gap-2 flex-wrap-wrap mt-2">
                    @for (t of c.tags; track $index) {
                    <div class="badge-container muted-g-bg flex align-items-center gap-1">
                      <i class="pi pi-tag"></i>
                      <small class="text-xs">{{ t }}</small>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="accordion-content">
                <div class="content-res flex align-items-end justify-content-between flex-wrap-wrap">
                  <div class="flex align-items-start gap-5">
                    <div>
                      <small><strong>Amministratore</strong></small>
                      <a [routerLink]="[
                                  '/user/profile',
                                  c.creator.username,
                                ]" class="block mt-2 flex align-items-center gap-2">
                        <p-avatar [image]="
                                    c.creator.profile_picture
                                      | imagePipe: 'user' : 'sm'
                                  " shape="circle"></p-avatar>
                        <small class="link-o text-sm">{{ c.creator.name }}
                          {{ c.creator.last_name }}</small>
                      </a>
                    </div>
                    <div class="mr-2">
                      <small><strong>Travelers</strong></small>
                      <div class="mt-2">
                        @if (c.users.length > 0) {
                        <p-avatarGroup>
                          @for (
                          u of c.users | slice: 0 : 6;
                          track $index
                          ) {
                          <p-avatar [image]="
                                          u.user.profile_picture
                                            | imagePipe: 'user-w' : 'sm'
                                        " shape="circle"></p-avatar>
                          }
                          @if (c.users.length > 6) {
                          <p-avatar [label]="'+' + usersLength(c)" shape="circle" [style]="{
                                          'background-color': '#3c4e58',
                                          color: '#ffffff',
                                        }"></p-avatar>
                          }
                        </p-avatarGroup>
                        } @else {
                        <div class="mt-07 grey-text">
                          <small class="text-sm">Nessun partecipante.</small>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-accordionTab>
          }
        </p-accordion>
      </div>
      }
      <div class="my-5">
        <h2>Assicurazione, termini e condizioni</h2>
        <div class="flex flex-column gap-3 my-3">
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/insurance.png" height="30" />
            <a (click)="insuranceTextDialog = true" class="green link-o">Consulta i termini e condizioni</a>
          </div>
          @if (luggage_attachment) {
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/protection-g.png" height="30" />
            <a [href]="environmentMediaUrl + '/' + luggage_attachment.path" class="green link-o">Consulta il testo
              dell'assicurazione medico bagaglio</a>
          </div>
          }
          @if (cancellation_attachment) {
          <div class="flex align-items-center gap-3">
            <img src="/assets/media/icons/cancel-insurance.png" height="30" />
            <a [href]="
                      environmentMediaUrl + '/' + cancellation_attachment.path
                    " class="green link-o">Consulta il testo dell'assicurazione annullamento</a>
          </div>
          }
        </div>
      </div>
      <div class="mt-3">
        <!-- @if(travel.companions.length > 0){
              <h2>Accompagnatore</h2>
              <div class="flex align-items-center gap-3 mt-3 clickable"
                [routerLink]="['/companions/companion-profile', travel.companions[0].companion.id]">
                <div class="companion-placeholder">
                  <img [src]="travel.companions[0].companion.profile_picture | imagePipe: 'user-w':'md'" width="60"
                    height="60">
                </div>
                <div>
                  <span class="mb-2">{{travel.companions[0].companion.name}}
                    {{travel.companions[0].companion.last_name}}</span>
                  <div class="grey-text companion_desc">
                    <small [innerHTML]="travel.companions[0].companion.description"></small>
                  </div>
                </div>
              </div>
              } -->
      </div>
      <div class="mt-3 mb-7">
        <h2 class="mb-2">Pagamenti disponibili</h2>
        <!-- @if(!isPaymentAvailable()){ -->
        <small class="grey-text">È possibile pagare tramite Stripe con carta di credito/debito o
          bonifico bancario SEPA entro il giorno prestabilito
          dall'organizzatore.</small>
        <!-- } -->
        <div class="flex align-items-center gap-3 mt-3">
          <!-- <div class="payment">
                  <img src="/assets/media/imgs/stripe.png" height="30">
              </div> -->
          <div class="payment">
            <img src="/assets/media/icons/visa.png" height="30" />
          </div>
          <div class="payment">
            <img src="/assets/media/icons/mastercard.png" height="30" />
          </div>
          <div class="payment">
            <img src="/assets/media/icons/amex.png" height="30" />
          </div>
          <div class="payment">
            <img src="/assets/media/icons/diners.png" height="30" />
          </div>
          <div class="payment">
            <img src="/assets/media/icons/discover.png" height="30" />
          </div>
        </div>
        <!-- @else {
                <small class="grey-text">Paga l'intero importo a rate con Scalapay!</small>
              } -->
        <!-- <div class="payments flex align-items-center gap-3 mt-5">
                <img src="/assets/media/icons/credit-card-full.png"
                  [ngClass]="isPaymentAvailable() ? 'hidden' : ''" />
                <img src="/assets/media/imgs/stripe-sm.png"
                  [ngClass]="isPaymentAvailable() ? 'hidden' : ''" />
                <img src="/assets/media/imgs/scalapay-sm.png"/>
              </div> -->
      </div>
      <div class="mt-3">
        <small class="grey-text">Rif. viaggio #{{ travel.internal_code }}</small>
      </div>
      <p-dialog header="Termini e condizioni" [modal]="true" [(visible)]="insuranceTextDialog"
        [style]="{ width: '50rem' }" [draggable]="false">
        <div [innerHTML]="travel.terms_and_conds">
          <!-- <span>{{ travel.terms_and_conds }}</span> -->
        </div>
      </p-dialog>
    </div>
    @if (travel.medias.length > 1) {
    <div class="col-12 md:col-6 pl-6">
      <div class="gallery">
        <div class="grid">
          <div class="col-12">
            <div class="first-img relative overflow-hidden" (click)="openGallery(0)">
              <!-- (click)="displayBasic = true" -->
              <img [src]="travel.medias[0].media | imagePipe: 'user' : 'lg'" class="block w-full" />
              <!-- @if (getTravel_metadata(0)) {
                      <small
                        class="absolute bottom-0 left-0 right-0 p-2 text-white text-xs font-italic text-center bg-black-alpha-60 opacity-0 transition-opacity duration-200"
                      >
                        {{ getTravel_metadata(0).author }}
                      </small>
                    } -->
            </div>
          </div>
          <div class="col md:col-12 xl:col">
            <div class="second-img relative overflow-hidden" (click)="openGallery(1)">
              <img [src]="travel.medias[1].media | imagePipe: 'user' : 'lg'" class="block w-full" />
              <!-- @if (getTravel_metadata(1)) {
                      <small
                        class="absolute bottom-0 left-0 right-0 p-2 text-white text-xs font-italic text-center bg-black-alpha-60 opacity-0 transition-opacity duration-200"
                      >
                        {{ getTravel_metadata(1).author }}
                      </small>
                    } -->
            </div>
          </div>
          @if (travel.medias.length > 2) {
          <div class="col">
            <div class="third-img relative overflow-hidden" (click)="openGallery(2)">
              <img [src]="
                          travel.medias[2].media | imagePipe: 'user' : 'lg'
                        " class="block w-full" />
              <!-- @if (getTravel_metadata(2)) {
                        <small
                          class="absolute bottom-0 left-0 right-0 p-2 text-white text-xs font-italic text-center bg-black-alpha-60 opacity-0 transition-opacity duration-200"
                        >
                          {{ getTravel_metadata(2).author }}
                        </small>
                      } -->
            </div>
          </div>
          }
          @if (travel.medias.length > 3) {
          <div class="col-1 md:col-2 xl:col-1">
            <div class="more-img" (click)="openGallery(3)">
              <small>+{{ travel.medias.length - 3 }}</small>
            </div>
          </div>
          }
        </div>

        <p-galleria [value]="travel.medias" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
          [containerStyle]="{ 'max-width': '850px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
          [showItemNavigators]="true" [showThumbnails]="false" [activeIndex]="activeIndexImg">
          <ng-template pTemplate="item" let-img>
            <div class="relative flex justify-content-center align-items-center w-full h-full">
              <img [src]="img.media | imagePipe: 'user' : 'lg'" class="max-h-screen w-auto object-contain" />

              @if (img.media.metadata) {
              <div class="absolute bottom-0 left-0 right-0 p-3 bg-black-alpha-70 text-white text-xs font-italic z-2">
                Photo by
                <a target="_blank" class="text-white" [href]="
                            getTravel_metadata(0).author_url +
                            '?utm_source=SocialTravels FE&utm_medium=referral'
                          ">{{ getTravel_metadata(0).author }}</a>
                on
                <a target="_blank" class="text-white"
                  href="https://unsplash.com/?utm_source=SocialTravels FE&utm_medium=referral">Unsplash</a>
              </div>
              }
            </div>
          </ng-template>
        </p-galleria>
      </div>
    </div>
    }
  </div>
</div>
} @else {
<div class="hero-dark"></div>
<div class="empty-set px-0">
  <img src="/assets/media/illustrations/map.png" height="200" />
  <h5>Qualcosa è andato storto</h5>
  <small class="grey-text">Non è stato possibile trovare questo viaggio!</small>
</div>
}
}

<!-- <div class="container"> -->

@if (suggested_travels.length >= 4) {
<div class="col-12 md:col-12 lg:col-12 pr-0">
  <div class="mt-6">
    <div class="travel-carousel mr-3 py-5">
      <h1 class="mt-0">
        Potrebbero interessarti anche <span class="green">questi</span>...
      </h1>
      <p-carousel [value]="suggested_travels" [numVisible]="4" [numScroll]="1" [responsiveOptions]="responsiveOptions"
        [showNavigators]="true">
        <ng-template let-t pTemplate="item">
          <div class="p-3 pt-0 h-full">
            <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>
}
@if (suggested_travels.length > 0 && suggested_travels.length < 4) { <div class="col-12 md:col-12 lg:col-12 pr-0">
  <div class="mt-6">
    <div class="travel-carousel mr-3 py-5">
      <h1 class="mt-0">
        Potrebbero interessarti anche <span class="green">questi</span>...
      </h1>
      <div class="grid justify-content-center">
        @for (t of suggested_travels; track $index) {
        <div class="col-12 md:col-6 lg:col-3 mt-4 mb-4">
          <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
        </div>
        }
      </div>
    </div>
  </div>
  </div>
  }

  <!-- </div> -->

  <!-- MODALE SUGGERIMENTO DI ISCRIZIONE -->
  <!-- <p-dialog
  [closable]="false"
  header="Vuoi registrarti alla piattaforma?"
  [modal]="true"
  [(visible)]="modalCanBeRegistered"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
>
  <ng-template pTemplate="body">
    <div class="text">
      <p>
        In pochi passi avrai il tuo account, potrai iniziare subito a esplorare
        contenuti e servizi dedicati e ti permetterà di entrare nella nostra
        community
      </p>
    </div>
    <div class="modal-footer flex justify-content-between gap-3">
      <p-button
        label="Non registrarmi"
        class="flex-grow-1 out-green"
        styleClass="w-full"
        (click)="modalCanBeRegistered = false; goToDonate()"
        [outlined]="true"
      ></p-button>

      <p-button
        class="flex-grow-1"
        label="Registrami"
        (click)="modalCanBeRegistered = false; goToRegister()"
        styleClass="slide w-full"
      ></p-button>
    </div>
  </ng-template>
</p-dialog> -->

  <!-- MODALE TERMINI E CONDIZIONI  DA INSERIRE -->
  <!-- <p-dialog
  [closable]="false"
  header="Termini e condizioni - evento GMG"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
 >
  <ng-template pTemplate="body">
    <div class="text">
      <section class="terms">
        <h2>1. Premessa</h2>
        <p>
          Il presente documento disciplina i termini e le condizioni relativi
          alla partecipazione e alle donazioni effettuate per i viaggi
          organizzati come progetti in fase di sviluppo. La natura progettuale
          implica che la realizzazione del viaggio non sia garantita.
        </p>

        <h2>2. Natura del Progetto</h2>
        <p>
          I viaggi proposti sono iniziative progettuali, soggette a valutazioni
          organizzative, logistiche ed economiche. La pubblicazione di un
          progetto non costituisce impegno vincolante alla sua effettiva
          realizzazione.
        </p>

        <h2>3. Donazioni</h2>
        <p>
          Le somme versate dagli utenti hanno natura di donazione e non di
          pagamento per un servizio già garantito. La donazione sostiene
          l’organizzazione e lo sviluppo del progetto, ma non dà diritto
          automatico alla partecipazione al viaggio. In caso di mancata
          realizzazione del progetto, la donazione non  sarà rimborsata, salvo
          diversa comunicazione ufficiale da parte dell’organizzazione.
        </p>

        <h2>4. Conferma del Viaggio</h2>
        <p>
          Solo al raggiungimento delle condizioni necessarie (es. numero minimo
          di partecipanti, copertura dei costi, autorizzazioni) il viaggio sarà
          confermato. L’organizzazione si riserva il diritto di modificare,
          rinviare o annullare il progetto.
        </p>

        <h2>5. Responsabilità</h2>
        <p>
          L’organizzazione non è responsabile per eventuali spese sostenute
          autonomamente dagli utenti (es. voli, assicurazioni, prenotazioni
          esterne) prima della conferma ufficiale del viaggio. La partecipazione
          sarà possibile solo dopo comunicazione formale di conferma da parte
          dell’organizzazione.
        </p>

        <h2>6. Comunicazioni</h2>
        <p>
          Gli utenti saranno informati tramite i canali ufficiali (email,
          piattaforma, sito web) circa lo stato del progetto e l’eventuale
          conferma o annullamento.
        </p>

        <h2>7. Accettazione</h2>
        <p>
          Effettuando la donazione e aderendo al progetto, l’utente dichiara di
          aver letto e accettato integralmente i presenti Termini e Condizioni.
        </p>
      </section>
    </div>
    <div class="modal-footer flex justify-content-between gap-3">
      <p-button
        label="Non accetto"
        class="flex-grow-1 out-green"
        styleClass="w-full"
        (click)="termsAndConditions = false"
        [outlined]="true"
      ></p-button>

      <p-button
        class="flex-grow-1"
        label="Accetto"
        (click)="termsAndConditions = false"
        styleClass="slide w-full"
     
      ></p-button>
    </div>
  </ng-template>
</p-dialog> -->
  <app-request></app-request>